import { Certificate } from './certificate-management.const';
import { CitationCheckManagement } from './citaition-check.const';
import { CourseManagementService } from './course-management.const';
import { ExamManagementService } from './exam-management.const';
import { ProceduresService } from './procedures.const';
import { ReportManagement } from './report-management.const';
import { SettingsService } from './settings.const';
import { TraineeCourse } from './trainee-course.const';
import { TrainingCenter, UserManagement } from './user-management.const';
import { NotificationManagementService } from "./notification-management.const";
import { PaymentService } from './payment';

export const ApplicationRoutes = {
    //#region User Management 5001
    Authentications: UserManagement.Authentication,
    Groups: UserManagement.Group,
    Lookups: UserManagement.Lookup,
    Roles: UserManagement.Role,
    Users: UserManagement.User,
    JobClassification: UserManagement.JobClassification,
    TrainingCenter: TrainingCenter.Controller,
    //#endregion

    //#region  Certificate 5002
    Certificate: Certificate,
    //#region

    //#region Exam 5003
    Exam: ExamManagementService.Exam,
    Question: ExamManagementService.Question,
    TraineeAnswer: ExamManagementService.TraineeAnswer,
    //#endregion

    //#region Course 5004
    Category: CourseManagementService.Category,
    CourseContent: CourseManagementService.CourseContent,
    CourseEvaluation: CourseManagementService.CourseEvaluation,
    CourseGeneralBrief: CourseManagementService.CourseGeneralBrief,
    Course: CourseManagementService.Course,
    CourseTopics: CourseManagementService.CourseTopics,
    CourseDiscussionLikeController: CourseManagementService.DiscussionLike,
    CourseTopicComment: CourseManagementService.CourseTopicComments,
    CourseFaqQuestion: CourseManagementService.CourseFaqQuestion,
    Language: CourseManagementService.Language,
    LearningPath: CourseManagementService.LearningPath,
    CourseMedia: CourseManagementService.CourseMedia,
    CourseVote: CourseManagementService.CourseVote,
    WebexMeeting: CourseManagementService.WebexMeeting,
    UserFeedback: CourseManagementService.UserFeedback,
    DigitalLibrary: CourseManagementService.DigitalLibrary,
    //#endregion

    //#region Student Course 5005
    TraineeCourse: TraineeCourse.TraineeCourse,
    Enrollment: TraineeCourse.Enrollment,
    Favorite: TraineeCourse.Favorite,
    TraineeLearningPath: TraineeCourse.TraineeLearningPath,
    TraineeProgress: TraineeCourse.TraineeProgress,
    Trainee: TraineeCourse.Trainee,
    TraineeVote: TraineeCourse.TraineeVote,
    TrainingPlan: TraineeCourse.TrainingPlan,
    //#endregion

    //#region Reports 5006
    CourseReport: ReportManagement.CourseReport,
    TraineeReport: ReportManagement.TraineeReport,
    //#endregion

    //#region Settings 5007
    Contact: SettingsService.Contact,
    Culture: SettingsService.Culture,
    Currency: SettingsService.Currency,
    CourseTabImage: SettingsService.CourseTabImage,
    Hint: SettingsService.Hint,
    Tour: SettingsService.Tour,
    DynamicSignUpForm: SettingsService.DynamicSignUpForm,
    HomeImage: SettingsService.HomeImage,
    HomeSection: SettingsService.HomeSection,
    Identity: SettingsService.Identity,
    Localizations: SettingsService.Localizations,
    MessageCategory: SettingsService.MessageCategory,
    MessagingConfig: SettingsService.MessagingConfig,
    Notification: SettingsService.Notification,
    Organization: SettingsService.Organization,
    Page: SettingsService.Page,
    PageFeedback: SettingsService.PageFeedback,
    Partner: SettingsService.Partner,
    Zoom: SettingsService.Zoom,
    WebexIntegration: SettingsService.WebexIntegration,
    VideoConferenceProvider: SettingsService.VideoConferenceProvider,
    Testimonial: SettingsService.Testimonial,
    TeamMember: SettingsService.TeamMember,
    PlatformFaq: SettingsService.PlatformFaq,
    HomeAdvertising: SettingsService.HomeAdvertising,    //#endregion

    //#region Citaition Check 5008
    DocumentContent: CitationCheckManagement.DocumentContent,
    TraineeAnswerCitation: CitationCheckManagement.TraineeAnswerCitation,
    //#endregion

    //#region Video Translation 5011
    Translator: {
        Translators: `video-translator/translators`,
    },
    //#endregion

    //#region Strorage 5012
    Storage: {
        Media: `storage/media`,
    },
    //#endregion

    //#region Procedures 5013
    Procedure: ProceduresService.Procedure,
    TrainingRequest: ProceduresService.TrainingRequest,
    CooperativeTraining: ProceduresService.CooperativeTraining,
    PractitionersTraining: ProceduresService.PractitionersTraining,
    TrainingNeeds: ProceduresService.TrainingNeeds,
    //#endregion

    //#region Payment 5015
    Payment: PaymentService,
    //#endregion Payment

    //#region Notification
    Notifications: NotificationManagementService
    //#endregion Notification
};
